import { DatePipe, formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PayoutService } from '../../_services';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AppConfig } from '../../_helpers/index';
import { Subscription, } from 'rxjs';
import { PayoutCommerceCreation, PayoutCommerceStatus } from '../../_enums/payout';
import { PayoutCommerceList, Data, Alert, Status } from '../../_models';
import { SelectionModel } from '@angular/cdk/collections';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { PayoutProcessCommerceMasiveConfirmService } from 'src/app/_services/payout-process-commerce-masive-confirm.service';

@Component({
  selector: 'app-payoutprocesscommerce',
  templateUrl: './payoutprocesscommerce.component.html',
  styleUrls: ['./payoutprocesscommerce.component.css', '../../../assets/css/customer-list-table.css']
})
export class PayoutprocessCommerceComponent implements OnInit, OnDestroy {

  searchTextFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  statusFilterFormControl = new FormControl(0);
  creationFormControl = new FormControl(3);
  ddlPayoutStatus: Status[];
  ddlPayoutCreation: Status[];
  statusDropdownValue: number = 0;
  isRangoVisiable: boolean = false;

  customerPublicId: string;
  userPublicId: string;

  // PAGINATION AND FILTER
  status: string = "";
  startDate: string = "";
  endDate: string = "";
  pageSize: number;
  pageIndex: number = 0;
  pageStart: number = 0;
  PageSizeOptions: number[];
  searchValue: string = '';
  records: number;

  // TIMEZONE
  offsetTimeZone: any;
  offsetMinutes: number = 0;
  offsetTimeVal: number;

  // MAT TABLE
  displayedColumns: string[] = ['select', 'created', 'reference', 'public_id', 'name', 'gross_amount.value', 'net_amount.value', 'status', 'commerce', 'actions'];
  dataSourcePayoutCommerceList = new MatTableDataSource();
  hasSelectionNoValue: boolean = true;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // CHECKBOX SELECTION
  payoutsSelected: { customer_public_ids: string; payout_public_ids: string; };
  selection = new SelectionModel<any>(true, []);
  payoutSelection = new SelectionModel<any>(true, []);

  getPayoutCommerceList$: Subscription;

  alerts: Alert[] = [];
  modalRef: BsModalRef;

  constructor(
    private formBuilder: FormBuilder,
    private payoutCommerceCreation: PayoutCommerceCreation,
    private payoutCommerceStatus: PayoutCommerceStatus,
    private payoutService: PayoutService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private datePipe: DatePipe,
    private modalService: BsModalService,
    private payoutMasiveConfirmService: PayoutProcessCommerceMasiveConfirmService
  ) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.ddlPayoutCreation = this.payoutCommerceCreation._creation;
    this.ddlPayoutStatus = this.payoutCommerceStatus._commerceStatus;

    this.searchTextFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.searchRangoFilterForm = this.formBuilder.group({
      searchFromDate: [''],
      searchToDate: ['']
    })
  }

  exclusiones: string[] = ['CANCELLED', 'CANCELLING'];

  ngOnInit() {
    this.spinnerService.show();
    this.setUserId();
    this.setTimeData();
    this.startDate = this.setTodayValueFilter('00:00:00');
    this.endDate = this.setTodayValueFilter('23:59:59');
    this.getPayoutCommerceList();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourcePayoutCommerceList.data.length;
    return numSelected === numRows;
  }

  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  toggleSelection(row) {
    this.payoutSelection.toggle(row);
    this.selection.toggle(row.public_id);
    this.payoutsSelected = this.payoutMasiveConfirmService.updateValue(this.payoutSelection.selected);
    this.hasSelectionNoValue = this.selection.isEmpty();
  }

  isAnySelected() {
    const numSelected = this.selection.selected.length;
    return numSelected > 0 && numSelected < this.dataSourcePayoutCommerceList.data.length;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  hideModal(reason: 'accept' | '' = ''): void {
    if (reason === 'accept') {
      const {customer_public_ids, payout_public_ids} = this.payoutsSelected;
      this.router.navigate(['/payout_process_commerce/masive-confirm'], {
        queryParams: { customer_public_ids, payout_public_ids}
      });
    }
    this.modalRef.hide();
  }

  setUserId() {
    let browserStorage;
    let browserStorage1 = localStorage.getItem('application');
    if (browserStorage1 === 'PAYOUTS') {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage === '' || browserStorage === undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicId = localStorage.getItem('companyId');
      }
    }
    this.userPublicId = localStorage.getItem('userId');
  }

  setTimeData() {
    let browserStorage;
    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = '-5.00';
    } else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
    }

    this.offsetTimeVal = (Number(this.offsetTimeZone) * 3600000);
    AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal.toString();
  }

  getFormValue(formGroup: FormGroup, formControlName: string) {
    return formGroup.get(formControlName).value;
  }


  isNotNull(value: string) {
    return value !== null;
  }

  isNotEmptyString(value: string) {
    return value !== '';
  }

  cleanAlerts() {
    this.alerts = [];
  }

  getPayoutCommerceList() {
    this.cleanAlerts();
    this.getPayoutCommerceList$ = this.payoutService.getCustomerPayoutProcessListProcessed(this.customerPublicId, this.status, this.startDate, this.endDate, this.pageSize, this.pageStart, this.searchValue).subscribe((data: PayoutCommerceList) => {
      let resources = this.filterPayoutList(data.data);
      this.addNoPayoutProcessingAlert(resources);
      this.dataSourcePayoutCommerceList.data = resources;
      this.records = data["records"];
      this.paginator.pageIndex = this.pageIndex;
      this.spinnerService.hide();
    }, error => {
      console.error('Failed! while trying to get the Operation Payout List. ' + error.error)
    })
  }

  filterPayoutList(payoutList: Data[]) {
    return payoutList.filter(payout => !this.exclusiones.includes(payout.status));
  }

  isAnyPayoutStatus(payoutList: Data[], status: string) {
    return payoutList.some(payout => payout.status === status);
  }

  addNoPayoutProcessingAlert(payoutList: Data[]) {
    let isAnyPayoutProcessing = this.isAnyPayoutStatus(payoutList, 'PROCESSING');
    if (!isAnyPayoutProcessing) {
      this.alerts.push({
        type: 'warning',
        msg: `Para continuar con el proceso, se debe confirmar primero en Tesorería`
      });
    }
  }

  onClosed(dismissedAlert: Alert) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  getPayoutCommerceListForFilter() {
    this.spinnerService.show();
    this.pageStart = 0;
    this.pageIndex = 0;
    this.selection.clear();
    this.payoutSelection.clear();
    this.hasSelectionNoValue = this.selection.isEmpty()
    this.getPayoutCommerceList();
  }

  statusFilter(status: number) {
    this.statusDropdownValue = status;

    const statusMap = {
      [this.ddlPayoutStatus[0].value]: "all",
      [this.ddlPayoutStatus[1].value]: '(1)',
      [this.ddlPayoutStatus[2].value]: '(2)',
      [this.ddlPayoutStatus[3].value]: '(3)',
      [this.ddlPayoutStatus[4].value]: '(0)',
      [this.ddlPayoutStatus[5].value]: '(5)',
      [this.ddlPayoutStatus[6].value]: '(7)'
    };

    this.status = statusMap[status] || "all";

    this.getPayoutCommerceListForFilter();
  }

  searchTextFilter() {
    let getSearchTextValue = this.searchTextFilterForm.controls.searchText.value;
    this.searchValue = getSearchTextValue.trim().toLowerCase();
    this.getPayoutCommerceListForFilter();
  }

  filterCreationDetails(creation: number) {

    const currentDate = new Date();

    const currentweekFirstDate = new Date();
    const currentweekLastDate = new Date();
    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    const lastweekFirstDate = new Date();
    const lastweekLastDate = new Date();
    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);

    const currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    const lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    let startDateVar;
    let endDateVar;
    let getPayoutCommerceListAvailable = false;

    switch (Number(creation)) {
      case 0:
        // All Datas Condition
        const currentDatee = new Date();
        const lastDatee = new Date();
        const startDatee = new Date();

        startDatee.setMonth(currentDatee.getMonth() - 2);
        lastDatee.setMonth(currentDatee.getMonth());

        // Asigna los valores calculados
        startDateVar = this.convertGMTTime(new Date(formatDate(new Date(startDatee), 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(new Date(lastDatee), 'yyyy-MM-dd 23:59:59', 'en-US')));

        getPayoutCommerceListAvailable = true;
        break;
      case 1:
        // Current Month Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        getPayoutCommerceListAvailable = true;
        break;
      case 2:
        // Current Week Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        getPayoutCommerceListAvailable = true;
        break;
      case 3:
        // Today Filter Condition
        currentDate.setDate(currentDate.getDate());
        startDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        getPayoutCommerceListAvailable = true;
        break;
      case 4:
        // Yesterday Filter Condition
        currentDate.setDate(currentDate.getDate() - 1);
        startDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        getPayoutCommerceListAvailable = true;
        break;
      case 5:
        // Last Week Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        getPayoutCommerceListAvailable = true;
        break;
      case 6:
        // Last Month Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        getPayoutCommerceListAvailable = true;
        break;
      case 7:
        // Range Filter Condition
        this.startDate = "";
        this.endDate = "";
        this.isRangoVisiable = true;
        break;
      case 8:
        this.isRangoVisiable = false;
        startDateVar = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US')));
        getPayoutCommerceListAvailable = true;
        break;
      default:
        this.startDate = this.setTodayValueFilter('00:00:00');
        this.endDate = this.setTodayValueFilter('23:59:59');
        getPayoutCommerceListAvailable = true;
        break;
    }
    if (getPayoutCommerceListAvailable) {
      this.startDate = startDateVar;
      this.endDate = endDateVar;
      this.getPayoutCommerceListForFilter();
    }
  }

  checkAndFilterCustomForm() {
    let searchFromDateValue = this.getFormValue(this.searchRangoFilterForm, 'searchFromDate');
    let searchToDateValue = this.getFormValue(this.searchRangoFilterForm, 'searchToDate');

    if (this.isNotNull(searchFromDateValue) && this.isNotNull(searchToDateValue) && this.isNotEmptyString(searchFromDateValue) && this.isNotEmptyString(searchToDateValue)) {
      this.filterCustomDate(searchFromDateValue, searchToDateValue);
    } else {
      this.isRangoVisiable = false;
      this.creationFormControl.setValue(3);
      this.startDate = this.setTodayValueFilter('00:00:00');
      this.endDate = this.setTodayValueFilter('23:59:59');
      this.getPayoutCommerceListForFilter();
    }
  }

  filterCustomDate(searchFromDateValue: string, searchToDateValue: string) {
    if (this.payoutCommerceCreation._creation.length > 8) {
      this.payoutCommerceCreation._creation.shift();
    }
    let filterValue = this.datePipe.transform(searchFromDateValue, "dd/MM/yyyy") + '-' + this.datePipe.transform(searchToDateValue, "dd/MM/yyyy");
    this.ddlPayoutCreation.unshift({ value: 8, name: filterValue });
    this.startDate = this.convertGMTTime(new Date(formatDate(searchFromDateValue, 'yyyy-MM-dd 00:00:00', 'en-US')));
    this.endDate = this.convertGMTTime(new Date(formatDate(searchToDateValue, 'yyyy-MM-dd 23:59:59', 'en-US')));
    this.creationFormControl.setValue(8);
    this.isRangoVisiable = false;
    this.getPayoutCommerceListForFilter();
  }

  convertGMTTime(startDate1: Date) {
    if (Number(this.offsetTimeZone) > 0) {
      const dateTimeZoneDiff = new Date(startDate1);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let formatDateValue = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return formatDateValue;
    } else {
      const timezoneAdjustedDate = new Date(startDate1.setHours(startDate1.getHours() - Number(this.offsetTimeZone)));
      const minuteAdjustedDate = new Date(timezoneAdjustedDate.setMinutes(timezoneAdjustedDate.getMinutes() - this.offsetMinutes));
      let formatDateValue = formatDate(minuteAdjustedDate, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return formatDateValue;
    }
  }

  setTodayValueFilter(hour: string) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const todaySelectedHour = new Date(formatDate(currentDate, `yyyy-MM-dd ${hour}`, 'en-US'));
    let todayDate = this.convertGMTTime(todaySelectedHour);
    return todayDate;
  }

  pageChange(event) {
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getPayoutCommerceList();
  }

  viewPayoutDetailsAction(publicId: string) {
    return this.router.navigate([`/payout_process_commerce/${publicId}/view`]);
  }

  ngOnDestroy() {
    this.getPayoutCommerceList$.unsubscribe();
  }

}
